<template>
  <div class="message-container">
    <div class="date" :key="message.id + '_date'" v-if="showDate">
      {{ createdAtDate }}
    </div>
    <div class="message" v-bind:class="{'mine': isMine, 'has-files': hasFiles}">
      <div class="author" @click="$modal.show('PopupAboutProfile', message.profileId)">
        <avatar v-if="showAvatar" :userid="message.profileId" />
      </div>
      <div class="content">
        <span class="bubble z-1">
          <template v-for="(file) in message.files">
            <span class="photo-cover thumb"
              :key="file.id + 'thumb' + message.id"
              v-if="file.thumbUrl"
              @click.prevent="$modal.show('PopupFilePreview', file)"
              v-bind:style="{'width': 100 / message.files.filter(f => f.thumbUrl).length + '%', 'background-image': 'url(' + encodeURI(file.thumbUrl) + ')'}">
              <i class="fas fa-eye"></i>
            </span>

            <div class="padding-h" v-else :key="file.id + 'msg' + message.id">
              <file-entry :file="file">
              </file-entry>
            </div>
          </template>
          <span class="text nl2br" v-linkified v-if="message.text">{{ message.text }}</span>
          <span class="edited-marker" v-if="message.updatedAt">Изменено</span>
        </span>
      </div>
      <span class="time" :title="createdAtBeauty">{{ createdAtTime }}</span>
      <button class="btn btn-transparent btn-small edit-button" type="button" @click="$emit('editMessage', message)" v-if="isEditable"><i class="fal fa-pencil"></i></button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import FileEntry from '@/components/FileEntry.vue';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'ChatMessage',
  components: {
    FileEntry,
    Avatar,
  },
  props: ['message', 'showAvatar', 'showDate'],
  computed: {
		...mapGetters(["authId"]),
    isMine() {
      return this.message.profileId == this.authId
    },
    isEditable() {
      // можно редактировать сообщения только первые 5 минут
      return this.isMine && this.message.text && new Date() - new Date(this.message.createdAt) < 300000
    },
    hasFiles() {
      return this.message.files.length > 0
    },
    createdAtBeauty() {
      return this.$moment.utc(this.message.createdAt).local().calendar()
    },
    createdAtTime() {
      return this.$moment.utc(this.message.createdAt).local().format('HH:mm');
    },
    createdAtDate() {
      return this.$moment.utc(this.message.createdAt).local().format('LL')
    },
  }
}
</script>

<style lang="css" scoped>
.message-container {
  display: flex;
  flex-direction: column;
}

.message {
  display: flex;
  flex-direction: row;
  margin-bottom: .5em;
  position: relative;
}

.message .author {
  display: inline-block;
  width: 4em;
  min-width: 4em;
  max-width: 4em;
  text-align: center;
  cursor: pointer;
}

.message.mine {
  flex-direction: row-reverse;
}

.message .content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 80%;
}

.message.has-files .content {
  width: 100%;
}

.message .bubble {
  position: relative;
  display: inline-block;
  background-color: #f1f2f3;
  border-radius: 1em;
  overflow: hidden; /* нужно чтоб тамбы картинок с радиусом были */
}
.message .bubble .text {
  display: inline-block;
  padding: .25em .5em;
  word-break: break-word;
}
.message.has-files .bubble .text {
  display: block;
}


.date {
  display: inline-block;
  margin: 0 auto;
  color: #444;
  font-size: .8rem;
  background-color: #f1f2f3;
  padding: .25rem 1rem;
  align-self: center;
  border-radius: 1rem;
}

.message .time {
  position: relative;
  margin: 0 .5rem;
  opacity: 0;
  color: #444;
  font-size: .7rem;
  align-self: flex-end;
  transition: opacity .2s ease-in-out;
}

.message:hover .time {
  opacity: 1;
}

.edit-button {
  opacity: 0;
  transition: opacity .2s ease-in-out;
}

.edit-button, .edit-button i {
  color: #666;
  font-size: .8rem;
  box-shadow: none;
}
.edit-button:hover, .edit-button:hover i {
  color: #000;
}

.message:hover .edit-button {
  opacity: 1;
}

.edited-marker {
  display: block;
  font-size: .8rem;
  color: #666;
  padding: 0 .8rem .25rem .5rem;
  text-align: right;
}


.thumb {
  display: inline-flex;
  height: 10rem;
  font-size: 2rem;
  cursor: pointer;
  color: #FFF;
  text-align: center;
  align-items: center;
  justify-content: center;
  min-width: 33.333%;

  transition: all .2s ease-in-out;
}
.thumb:hover {
  box-shadow: inset 0 0 20em rgba(0,0,0,0.3);
}

.thumb > i {
  opacity: 0;
  transition: opacity .2s ease-in-out;
}
.thumb:hover > i {
  opacity: 1;
}
</style>